import { IAuthAPI } from '@/features/api/auth/types'
import AxiosHttpFactory from '@/features/api/axiosHttpFactory'
import { ErrorTransformInterceptor } from '@/features/api/errorTransformInterceptor'
import { MissingNetworkConnectionInterceptor } from '@/features/api/missingNetworkConnectionInterceptor'
import { DeviceInfo } from '@/features/auth/types'
import { AxiosError } from 'axios'

class AuthAPI implements IAuthAPI {
    private $authAPI = AxiosHttpFactory.createMultiClient()

    constructor() {
        new MissingNetworkConnectionInterceptor(this.$authAPI)

        new ErrorTransformInterceptor(this.$authAPI)
    }

    setHostUrl(url: string) {
        this.$authAPI.defaults.baseURL = `${url}/api/terminal-auth`
    }

    async requestDeviceAuthorization(deviceInfo: DeviceInfo) {
        const { data } = await this.$authAPI.post<{ deviceId: string }>('/request-authorization', {
            deviceInfo,
        })

        return data.deviceId
    }

    async authorizeDevice(deviceId: string, authorizationCode: string) {
        const formData = new FormData()
        formData.append('deviceId', deviceId)
        formData.append('authorizationCode', authorizationCode)

        const { data } = await this.$authAPI.post<{ accessToken: string }>('/authorize', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            extras: {
                errorIdentifier: (error: AxiosError<{ error: { code: number } }>) =>
                    error.response?.data.error.code.toString(),
            },
        })

        return data.accessToken
    }
}

export default new AuthAPI()
